import React from "react";
import Header from "../../../headers/Header";

const HeaderOnlyLayout = ({ children }) => {
    return (
        <>
            <Header />
            <div style={{ height: "calc(100vh - 92px)", width: "100%", overflow: "hidden" }}>
                {children}
            </div>
        </>
    );
};

export default HeaderOnlyLayout;
